// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UUo4","col":"styles_col__19KO6"};